module.exports = __webpack_public_path__ + "img/modal-purchase-null.8bb8c751.svg";